//购买渠道
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box" @tab-click="handleClick">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
          @reload="$reloadHandle" :initTableList="initTableList"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="height: calc(100vh - -35px);">
          <vxe-grid  :stripe="true" ref="table-m1" v-bind="gridData" show-overflow height="100%"  border="default"  :row-config="{ isHover: true }"
            @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">
            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
                    @click="openEditDialog" v-if="buyChannelSave">新增</vxe-button>
                </div>
                <div class="fr">
<!--                  <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text" status="primary"-->
<!--                    plain>重置</vxe-button>-->
                  <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                    @click="searchEvent">搜索</vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="requestParam"
              @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                <vxe-form-item title="购买渠道名称:" field="SLAName">
                  <template v-slot>
                    <el-input v-model="searchValue" size="small" clearable />
                  </template>
                </vxe-form-item>
              </vxe-form>
            </template>
            <template #pager class="pager_left">
              <pager  ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import editView from './edit.vue';
import { tableOption } from '@/const/crud/admin/tenant';
import { initVxeTable } from '@/const/crud/admin/table';
import api from "@/api/projectApi";
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
export default {
	name: 'channel',
  components: { editView, pager },
  data() {
    return {
      buyChannelSave: false,
      buyChannelEdit: false,
      total: 0,
      requestParam: {
        searchCount: false,  // 是否分页
        buyChannelName: null,  // 来源名称
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
      },
      pageSizes: [20, 50, 100],
      gridData: {},
      showEdit: false,
      activeName: 'second',
      dataId: 0,
      column: [
        { type: 'seq', title: '序号', width: 60, resizable: false, fixed: 'left' },
        { title: '购买渠道名称', field: 'buyChannelName', width: 200, },
        { title: '购买渠道别名', field: 'wxBuyChannelName', width: 200, },
        { title: '是否在微信中显示', field: 'isShowwx', width: 200, slots: { default: ({ row }) => {
              if (row.isShowwx == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isShowwx == 1) {
                return [
                  <div class="txt-status">
                    <span>是</span>
                  </div>
                ];
              }
            }}},
        { title: '是否在发布中显示', field: 'isShowIssue', width: 200, slots: { default: ({ row }) => {
              if (row.isShowIssue == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isShowIssue == 1) {
                return [
                  <div class="txt-status">
                    <span>是</span>
                  </div>
                ];
              }
            }}},
        { title: '是否在自建中显示', field: 'isShowSiteIssue', width: 200, slots: { default: ({ row }) => {
              if (row.isShowSiteIssue == 0) {
                return [
                  <div class="txt-status disable">
                    <span>否</span>
                  </div>
                ];
              } else if (row.isShowSiteIssue == 1) {
                return [
                  <div class="txt-status">
                    <span>是</span>
                  </div>
                ];
              }
            }}},
        { title: '创建时间', field: 'createTime', width: 200, },
        { title: '创建人', field: 'createBy', width: 200, },
        { width: 60, fixed: 'right', title: '操作', sortable: false, slots: {
            default: ({ row }) => {
              return [
                <div>
                  <a href="javascript:void(0);" class="a-link"
                    onclick={() => {
                      this.openEditDialog(row.id);
                    }}
                  >
                    <el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
                      <i class="el-icon-edit" />
                    </el-tooltip>
                  </a>
                </div>
              ];
            }
          }
        }
      ],
      searchValue: null
    };
  },
  mounted() {
    // this.getTableData();
    this.buyChannelEdit = this.permissions['buy_channel_edit']
    this.buyChannelSave = this.permissions['buy_channel_add']
  },
  watch: {
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  methods: {
    toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },

    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.basBuyChannel.getTableDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.column
      };
      this.gridData = initVxeTable(tableOption);
      // this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    handleClick(tab, event) {
      console.log(tab, event, 'handleClick');
      this.flushed()
    },

    // updateChange() {
    //   this.flushed()
    // },

    // 搜索
    searchEvent() {
      this.requestParam.buyChannelName = this.searchValue
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // // 重置
    // resetEvent() {
    //   this.searchValue = ''
    //   this.requestParam.searchCount = false
    //   this.requestParam.current = 1
    //   this.requestParam.orderTypeName = ''
    //   this.$refs.pager.reset()  // 重置分页器
    //   this.flushed()
    // },
    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },
  }
};
</script>


<style lang="scss" >
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}
.pager_left{
  margin-left: 1px;
}
</style>
